import { AppEnvironment } from "@/client/core/Core.api";
import { LabsMessageToPlatformType } from "@/client/core/platform-types/labs.api";
import { createSendPluginMessage } from "@/client/core/services/plugin-send-message";
import { getAppEnvironment } from "@/client/utils/getAppEnvironment";
import { noop } from "@/shared/utils/noop";

export interface PageChangeService {
    onPageChange: (href: string) => void;
}

export const createPageChangeService = (): PageChangeService => {
    const environment = getAppEnvironment();

    switch (environment) {
        case AppEnvironment.Plugin: {
            const sendMessage = createSendPluginMessage(noop, noop);

            return {
                onPageChange: (pathname) => {
                    sendMessage({
                        type: LabsMessageToPlatformType.PageChange,
                        pathname,
                    });
                    sendMessage({
                        type: LabsMessageToPlatformType.ClearElementaryResourceCache,
                    });
                },
            };
        }
        case AppEnvironment.Website: {
            return { onPageChange: noop };
        }
    }
};
